export interface IErrorItem {
  row: string;
  errorMessage: string;
}

export interface IPropsNotificationErrorModalErrorModal {
  onConFirm?: () => void;
  errorMessage?: string;
  confirmText?: string;
}

const NotificationErrorModalErrorModal = (props: IPropsNotificationErrorModalErrorModal) => {
  const { onConFirm, confirmText, errorMessage } = props;

  return (
    <>
      <div className="modal modal-open">
        <div className="relative modal-box max-w-[76vw] w-[76vw]">
          <div className="rounded-md mt-12 overflow-auto h-[60vh] scrollbar-hide">
            <table className="table w-full table-zebra font-tt">
              <thead>
                <tr>
                  <th>เกิดข้อผิดพลาดในการทำรายการ กรุณาตรวจสอบความถูกต้อง แล้วลองบันทึกอีกรอบ</th>
                </tr>
              </thead>
              <tbody>
                <td>{errorMessage}</td>
              </tbody>
            </table>
          </div>

          <div className="flex justify-end w-full pt-24 space-x-4">
            <button className="btn btn-error" onClick={onConFirm}>
              {confirmText || 'OK, I’m noticed'}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotificationErrorModalErrorModal;
